import { NavLink } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { isAdminRole, maskDoc } from "@/lib/api";
import { toast } from "sonner";

const copyCode = (code) => { navigator.clipboard?.writeText(String(code)); toast.success("Código de acesso copiado"); };

function CodeBtn({ code, testId }) {
  return (
    <button type="button" onClick={() => copyCode(code)} title="Copiar código de acesso" className="font-mono font-semibold underline-offset-2 hover:underline" data-testid={testId}>{code}</button>
  );
}

export function CompanyCard({ tenant, user }) {
  const uf = tenant.endereco?.uf || "—";
  const body = (
    <div className="min-w-0 flex-1 space-y-1 text-xs leading-snug">
      <p className="line-clamp-2 font-display text-sm font-bold uppercase" title={tenant.razao_social || tenant.nome_fantasia} data-testid="sidebar-company-name">{tenant.razao_social || tenant.nome_fantasia}</p>
      <p data-testid="sidebar-company-doc">CPF/CNPJ: <span className="whitespace-nowrap">{tenant.documento ? maskDoc(tenant.documento) : "—"}</span></p>
      <p>Código: <CodeBtn code={tenant.access_number} testId="sidebar-access-code" /> <span className="opacity-60">|</span> UF: <span data-testid="sidebar-company-uf">{uf}</span></p>
      <p className="truncate" title={user.name} data-testid="sidebar-company-user">Usuário: {user.name}</p>
    </div>
  );
  return (
    <div className="flex items-center gap-1 rounded-xl bg-primary p-3.5 text-primary-foreground shadow-[0_8px_24px_hsl(var(--primary)/0.25)]" data-testid="sidebar-company-card">
      {body}
      {isAdminRole(user) && (
        <NavLink to="/app/sistema/empresa" aria-label="Abrir Minha empresa" className="grid h-8 w-6 shrink-0 place-items-center rounded-lg transition-colors hover:bg-white/15" data-testid="sidebar-company-open">
          <ChevronRight className="h-5 w-5" />
        </NavLink>
      )}
    </div>
  );
}

export function CompanyCompact({ tenant, user }) {
  return (
    <div className="min-w-0" data-testid="mobile-company-card">
      <p className="truncate font-display text-sm font-bold uppercase">{tenant.razao_social || tenant.nome_fantasia}</p>
      <p className="truncate text-xs text-muted-foreground">Código: <CodeBtn code={tenant.access_number} testId="mobile-access-code" /> · UF: {tenant.endereco?.uf || "—"} · {user.name}</p>
    </div>
  );
}
